import request from '@/utils/request'
// 获取左侧列表
export const getReportList = params => {
    return request({
        method: 'POST',
        url: '/graphicallightweightdata/ms/findNewReports',
        data: params
    })
}
// 获取轮播列表
export const getRotationList = params => {
    return request({
        method: 'POST',
        url: '/graphicallightweightdata/ms/findRotationList',
        data: params
    })
}
// 获取轮播数据
export const getRotationData = params => {
    return request({
        method: 'POST',
        url: '/graphicallightweightdata/ms/findRotationData',
        data: params
    })
}